import { getTokenClaims } from '@ms/yammer-web-authenticators';

import { get, remove, set } from '../cookies';

import { ShouldWriteCookie, WriteCookie, WriteHostingCookieOptions, writeHostingCookie } from './writeHostingCookie';

const DefaultAnchorMailboxCookieName = 'DefaultAnchorMailbox';

const cookieWithValueExists = (newValue: string) => {
  const existingValue = get(DefaultAnchorMailboxCookieName);

  return existingValue === newValue;
};

const shouldWriteCookie: ShouldWriteCookie = (yammerToken: string) => {
  const { upn } = getTokenClaims(yammerToken);
  if (cookieWithValueExists(upn)) {
    return false;
  }

  return true;
};

const writeCookie: WriteCookie = (yammerToken, options) => {
  const { upn } = getTokenClaims(yammerToken);

  const cookieOptions = {
    ...options,
    encode: (cookie: string) => cookie,
  };

  set(DefaultAnchorMailboxCookieName, upn, cookieOptions);
};

type WriteRoutingCookie = (yammerToken: string, shouldSetSameSite?: boolean) => void;
export const writeRoutingCookie: WriteRoutingCookie = (yammerToken, shouldSetSameSite = false) => {
  const options: WriteHostingCookieOptions = {
    cookieName: DefaultAnchorMailboxCookieName,
    cookieValue: yammerToken,
    shouldWriteCookie,
    writeCookie,
    shouldSetSameSite,
  };

  writeHostingCookie(options);
};

type ClearRoutingCookie = () => void;
export const clearRoutingCookie: ClearRoutingCookie = () => {
  remove(DefaultAnchorMailboxCookieName);
};
